import { render, staticRenderFns } from "./StudyUnitCell.vue?vue&type=template&id=52829d04&scoped=true"
import script from "./StudyUnitCell.vue?vue&type=script&lang=js"
export * from "./StudyUnitCell.vue?vue&type=script&lang=js"
import style0 from "./StudyUnitCell.vue?vue&type=style&index=0&id=52829d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52829d04",
  null
  
)

export default component.exports